import { ChangeEvent, FC } from 'react';

import { VideoRoiCalculatorFieldProps } from './videoRoiCalculatorTypes';

const VideoRoiCalculatorTextField: FC<VideoRoiCalculatorFieldProps> = ({
  title,
  value,
  onChange,
  id,
  name,
  min,
  max,
  placeholder,
  unitSuffix,
}) => {
  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    // Remove non-numeric characters and limit to max value
    const numericValue = Number(event.target.value.replace(/[^0-9.]/g, ''));
    const newValue = max ? Math.min(numericValue, Number(max)) : numericValue;
    if (isNaN(newValue)) return;

    onChange(newValue);
  };

  return (
    <>
      <label htmlFor={id} className="mb-2 mt-3 block text-lg font-bold">
        {title} {unitSuffix && <span>{unitSuffix}</span>}
      </label>
      <input
        type="text"
        id={id}
        name={name}
        min={min}
        max={max}
        placeholder={placeholder}
        value={value}
        onChange={handleInputChange}
        className="min-h-11 w-full rounded-md border-0 pl-4"
      />
    </>
  );
};
export default VideoRoiCalculatorTextField;
